<template>
  <div class="gray-bg content">
    <div class="login-content">
      <p class="title">益体康 <span class="dot"></span> 项目经理端</p>
      <div class="form-content">
        <el-input type="text" @keyup.enter.native="login" v-model="username" placeholder="用户名" prefix-icon="el-icon-user" clearable></el-input>
        <el-input type="password" @keyup.enter.native="login" v-model="pwd" placeholder="密码" prefix-icon="el-icon-lock" clearable></el-input>
        <el-checkbox v-model="checked" style="width:280px;text-align: left;color:#333333;">记住用户名和密码</el-checkbox>
        <el-button type="primary" @click="login" :disabled="loginDisabled">登录</el-button>
        <p>版本号 V2.4.1</p>
      </div>
    </div>
    <p class="footer">
      <small>Copyright@2001-现在 益体康（北京）科技有限公司
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="padding-left: 10px;">京ICP备09007401号-12</a>
        <img src="../assets/img/gongan.png" style="padding-left: 10px;">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802036751" target="_blank">京公网安备 11010802036751号</a>
      </small>
    </p>
    <p class="download"> <a href="https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/pdfdownloader_beta1.0.0.3.exe">报告批量下载工具 v1.0.0.3</a></p>
  </div>

</template>

<script>
  import ApiService from "../service/ApiService";
  import pub from "../service/public";
  export default {
    name: "Login",
    data() {
      return {
        username: "",
        pwd: "",
        checked: false,
        loginDisabled:false,
      }
    },
    created() {
      this.$cookies.set(pub.token.token_key, '');//token authorization  post传值需要的
      this.$cookies.set(pub.token.token_role_name, '');
      this.$cookies.set(pub.token.token_usrname, '');//用户名
      this.$cookies.set(pub.token.refresh_key, '');//用来刷新authorization

      let name = this.$cookies.get("save_usrname_wf");
      let pwd = this.$cookies.get("save_pwd_wf");
      if (name != '' || pwd != '') {
        this.username = name;
        this.pwd = pwd;
        this.checked = true;
      }
    },
    methods: {
      login() {
        let that = this;
        if (that.username == "") {
          this.$message({
            showClose: true,
            message: '用户名不能为空',
            type: 'warning',
            duration: 1500
          });
        } else if (that.pwd == "") {
          that.$message({
            showClose: true,
            message: '密码不能为空',
            type: 'warning',
            duration: 1500
          });
        } else {
          that.loginDisabled = true;
          let params = {
            page: {
              number: 0,
              limit: 1
            },
            keyWord: [],
            parms: {
              usrName: this.username.trim(),
              usrPwd: this.pwd.trim()
            }
          };
          ApiService.userLogin(params).then(res => {
            that.loginDisabled = false;
            if (res.code == 0) {
              that.$cookies.set(pub.token.token_key, res.data.pageList[0].authorization);//token authorization  post传值需要的
              that.$cookies.set(pub.token.refresh_key, res.data.pageList[0].refreshToken);//用来刷新authorization
              localStorage.setItem('UL_WF_UsrInfo',JSON.stringify(res.data.pageList[0]));
              if (that.checked == true) {
                that.$cookies.set("save_usrname_wf", that.username);
                that.$cookies.set("save_pwd_wf", that.pwd);
              }
              that.$cookies.set('page_title_ul_wf', '心贴信息-数据列表(记录管理)');
              that.$router.push("/recordList");
            } else {
              pub.analysisReturnCode(res);
            }
          }).catch(error => {
            that.loginDisabled = false;
            if (error == "Error: Request failed with status code 400") {
              pub.tip(error,'error');
            }
            console.log("登录报错信息：", error)
          });
        }

      },
      resizeHeightHandler() {
        let htmlHeight = document.documentElement.clientHeight || document.body.clientHeight;
        document.querySelector('.content').style.minHeight = (htmlHeight) + 'px'//给内容撑开，让页面更加规整
      },

    },
    beforeMount() {
      window.addEventListener('resize', this.resizeHeightHandler);//响应式
    },
    destroyed() {
      window.removeEventListener('resize', this.resizeHeightHandler)
    },
    mounted() {
      this.resizeHeightHandler();
    },
  }
</script>

<style scoped="scoped" lang="scss">
 .content{
   width: 100%;
   height: 100%;
   background: url("../assets/img/bj.jpg") no-repeat center;
   background-size: cover;
   min-width: 1360px;
   text-align: center;
   position: relative;
 }
  .login-content {
    position: absolute;
    width: 400px;
    height: 400px;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -200px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 12px rgba(0,0,0,0.2);
  }
  .login-content .title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 20px;
    text-align: center;
    color: #333333;
    font-weight: normal;
    margin-top: 40px;
  }
  .login-content .title .dot{
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background: #666666;
    position: relative;
    top: -3px;
  }
  .login-content .form-content{
    width: 300px;
    height: 250px;
    padding-top: 10px;
    margin: 0 auto;
  }
  .login-content .form-content .el-input {
    margin-bottom: 20px;
    width: 280px;
  }
  >>>.el-input__inner,>>>.el-input::-webkit-scrollbar-corner,>>>.el-input::-webkit-scrollbar-track-piece{
    background: none !important;
    border-radius: 20px;
    color: #333333;
  }
  .login-content .form-content .el-button {
    width: 280px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 20px;
    background: rgb(37,171,227);
    border-color: rgb(37,171,227);
  }
  >>>.el-checkbox__input.is-checked+.el-checkbox__label{
    color: rgb(37,171,227);
  }
  >>>.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background: rgb(37,171,227);
    color: rgb(37,171,227);
    border-color: rgb(37,171,227);
  }
  .footer,.download{
    min-width: 1360px;
    position: fixed;
    bottom: 80px;
    color: #ffffff;
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    a{
      color: #ffffff;
    }
  }
  .download{
    bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue